/* EaseDaily product page behavior: variant picker, countdown, count-up stats,
   sticky add-to-cart bar, accordions, share button, ajax add-to-cart. */
(function () {
  'use strict';

  var root = document.querySelector('[data-ed-product]');
  if (!root) return;

  /* ---- Variant picker ---- */
  var variantInput = root.querySelector('[data-ed-variant-id]');
  var priceSaleEl = root.querySelector('[data-ed-price-sale]');
  var priceMrpEl = root.querySelector('[data-ed-price-mrp]');
  var priceDiscountEl = root.querySelector('[data-ed-price-discount]');
  var countdownWrap = root.querySelector('[data-ed-countdown-wrap]');
  var countdownDiscountEl = root.querySelector('[data-ed-countdown-discount]');
  var atcBtn = root.querySelector('[data-ed-atc]');
  var buyNowBtn = root.querySelector('[data-ed-buy-now]');
  var pills = root.querySelectorAll('[data-ed-variant-pill]');

  var stickyBar = document.querySelector('[data-ed-sticky-bar]');
  var stickyAtcBtn = stickyBar ? stickyBar.querySelector('[data-ed-sticky-atc]') : null;
  var stickyTitleEl = stickyBar ? stickyBar.querySelector('[data-ed-sticky-title]') : null;
  var stickyPriceEl = stickyBar ? stickyBar.querySelector('[data-ed-sticky-price]') : null;

  /* ---- Thumbnail gallery (images + product video) ---- */
  var mainImg = root.querySelector('#ed-product-main-img');
  var mainVideoHost = root.querySelector('[data-ed-main-video]');
  var videoPlayersHost = root.querySelector('[data-ed-video-players]');
  var thumbs = root.querySelectorAll('[data-ed-thumb]');

  /* Stop whichever video is currently sitting in the main display area (if
     any) and hand its markup back to the hidden players tray, so it isn't
     silently playing in the background after the viewer switches away. */
  function parkActiveVideo() {
    if (!mainVideoHost || !videoPlayersHost) return;
    var playing = mainVideoHost.querySelector('video');
    if (playing) playing.pause();
    while (mainVideoHost.firstChild) {
      videoPlayersHost.appendChild(mainVideoHost.firstChild);
    }
    mainVideoHost.style.display = 'none';
  }

  function showImage(src) {
    parkActiveVideo();
    if (mainImg && src) {
      /* Shopify's image_tag filter auto-generates a srcset/sizes pair on the
         main image, and browsers prefer srcset over a plain src change — so
         just setting .src silently did nothing. Clear srcset/sizes first so
         the swap actually takes effect. */
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = src;
      mainImg.style.display = '';
    }
  }

  function showVideo(mediaId) {
    if (!mainVideoHost || !videoPlayersHost) return;
    var player = videoPlayersHost.querySelector('[data-ed-video-player][data-ed-media-id="' + mediaId + '"]');
    if (!player) return;
    parkActiveVideo();
    if (mainImg) mainImg.style.display = 'none';
    mainVideoHost.appendChild(player);
    mainVideoHost.style.display = '';
    var videoEl = player.querySelector('video');
    if (videoEl) {
      videoEl.play().catch(function () {
        /* Autoplay can be blocked by the browser — that's fine, the
           viewer can just press the visible play control themselves. */
      });
    }
  }

  /* Given a variant pill, switch the main gallery image to that variant's
     own photo (if it has one) and sync the active thumbnail highlight to
     match, so clicking "Lord Shiv LED" shows the Shiv photo, etc. */
  function syncGalleryToVariant(pill) {
    var variantImageSrc = pill.getAttribute('data-ed-variant-image');
    if (!variantImageSrc) return;

    showImage(variantImageSrc);

    if (thumbs.length) {
      var variantMediaId = pill.getAttribute('data-ed-variant-media-id');
      var matched = null;
      if (variantMediaId) {
        thumbs.forEach(function (t) {
          if (t.getAttribute('data-ed-media-image-id') === variantMediaId) matched = t;
        });
      }
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      if (matched) matched.classList.add('is-active');
    }
  }

  function selectVariant(pill) {
    pills.forEach(function (p) { p.classList.remove('is-selected'); p.setAttribute('aria-pressed', 'false'); });
    pill.classList.add('is-selected');
    pill.setAttribute('aria-pressed', 'true');

    var id = pill.getAttribute('data-ed-variant-pill');
    var priceText = pill.getAttribute('data-ed-price-display');
    var mrpText = pill.getAttribute('data-ed-mrp-display');
    var discountText = pill.getAttribute('data-ed-discount-display');
    var discountPercent = pill.getAttribute('data-ed-discount-percent');
    var available = pill.getAttribute('data-ed-available') === 'true';

    if (variantInput) variantInput.value = id;
    if (priceSaleEl && priceText) priceSaleEl.textContent = priceText;
    /* A variant with no genuine MRP (no real compare-at price) has nothing
       honest to show as a struck-through "was" price, so the MRP figure
       hides itself rather than rendering an empty "₹" with nothing after
       it — the bug this block fixes. */
    if (priceMrpEl) {
      var hasMrp = parseFloat(discountPercent) > 0;
      if (hasMrp && mrpText) priceMrpEl.textContent = mrpText;
      priceMrpEl.style.display = hasMrp ? '' : 'none';
    }
    if (priceDiscountEl) {
      if (discountText) {
        priceDiscountEl.textContent = discountText;
        priceDiscountEl.style.display = '';
      } else {
        priceDiscountEl.style.display = 'none';
      }
    }
    /* The urgency countdown's "X% off" figure is rendered server-side for
       whichever variant was selected at page load, so without this it kept
       showing that original number no matter which swatch you picked
       afterwards. Keep it in sync with the price badge above. */
    if (countdownDiscountEl && discountPercent) {
      countdownDiscountEl.textContent = discountPercent;
    }
    /* A variant with no genuine MRP difference (e.g. buying a single lamp on
       its own) has nothing honest to put in an urgency countdown, so the
       whole timer hides itself rather than showing a hollow "0% off".
       It reappears the moment a variant with a real discount (like a
       bundle) is selected. */
    if (countdownWrap) {
      var hasRealDiscount = parseFloat(discountPercent) > 0;
      countdownWrap.style.display = hasRealDiscount ? '' : 'none';
    }

    [atcBtn, buyNowBtn, stickyAtcBtn].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = !available;
      btn.textContent = available ? (btn.getAttribute('data-ed-label') || 'Add to cart') : 'Sold out';
    });

    /* Keep the sticky bar's own title/price in sync with the selected variant. */
    if (stickyPriceEl && priceText) {
      stickyPriceEl.textContent = stickyPriceEl.hasAttribute('data-ed-sticky-price-short')
        ? priceText.replace(/\.00$/, '')
        : priceText;
    }
    if (stickyTitleEl) {
      var pillLabel = pill.querySelector('.ed-product__variant-name');
      if (pillLabel) stickyTitleEl.textContent = pillLabel.textContent.trim();
    }

    /* Swap the main product photo to match whichever variant was just picked. */
    syncGalleryToVariant(pill);
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () { selectVariant(pill); });
  });

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');

      var mediaType = thumb.getAttribute('data-ed-media-type');
      if (mediaType === 'video' || mediaType === 'external_video') {
        showVideo(thumb.getAttribute('data-ed-media-id'));
      } else {
        showImage(thumb.getAttribute('data-ed-full-src'));
      }
    });
  });

  /* ---- Ajax add to cart ---- */
  var cartForm = root.querySelector('[data-ed-cart-form]');
  var atcStatus = root.querySelector('[data-ed-atc-status]');

  function updateHeaderCartCount(itemCount) {
    var badgeHosts = document.querySelectorAll('[data-ed-cart-icon]');
    badgeHosts.forEach(function (host) {
      var badge = host.querySelector('[data-ed-cart-count]');
      if (itemCount > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'ed-icon-btn__badge';
          badge.setAttribute('data-ed-cart-count', '');
          host.appendChild(badge);
        }
        badge.textContent = itemCount;
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function addToCart(redirectToCheckout) {
    if (!variantInput || !variantInput.value) return;
    var body = { id: variantInput.value, quantity: 1 };

    if (atcStatus) atcStatus.textContent = 'Adding…';
    [atcBtn, stickyAtcBtn].forEach(function (btn) {
      if (btn) btn.disabled = true;
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        if (redirectToCheckout) {
          window.location.href = '/checkout';
          return;
        }
        if (atcStatus) atcStatus.textContent = 'Added to cart';
        [atcBtn, stickyAtcBtn].forEach(function (btn) {
          if (btn) btn.disabled = false;
        });
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) { updateHeaderCartCount(cart.item_count); })
          .catch(function () {});
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.setTimeout(function () {
          if (atcStatus) atcStatus.textContent = '';
        }, 2500);
      })
      .catch(function () {
        if (atcStatus) atcStatus.textContent = 'Could not add to cart — try again.';
        [atcBtn, stickyAtcBtn].forEach(function (btn) {
          if (btn) btn.disabled = false;
        });
      });
  }

  if (atcBtn) atcBtn.addEventListener('click', function () { addToCart(false); });
  if (buyNowBtn) buyNowBtn.addEventListener('click', function () { addToCart(true); });
  if (stickyAtcBtn) stickyAtcBtn.addEventListener('click', function () { addToCart(false); });

  /* ---- Countdown timer (urgency banner, resets at a fixed IST wall-clock
     time — e.g. every 12 hours at 5pm — instead of just looping a fixed
     duration from whenever the page happened to load). ---- */
  var countdownEl = root.querySelector('[data-ed-countdown]');
  if (countdownEl) {
    var cycleHours = parseFloat(countdownEl.getAttribute('data-ed-countdown-cycle-hours'));
    if (!cycleHours || cycleHours <= 0) cycleHours = 12;
    var anchorHour = parseFloat(countdownEl.getAttribute('data-ed-countdown-anchor-hour'));
    if (isNaN(anchorHour)) anchorHour = 17;

    var MS_PER_HOUR = 3600000;
    var MS_PER_DAY = 86400000;
    var IST_OFFSET_MS = 5.5 * MS_PER_HOUR;
    var cycleMs = cycleHours * MS_PER_HOUR;
    var anchorMs = anchorHour * MS_PER_HOUR;

    function pad(n) { return String(n).padStart(2, '0'); }

    /* Everything below is done in "IST-shifted" epoch ms — i.e. the real
       UTC epoch plus the IST offset — purely as an arithmetic trick so we
       can find day boundaries with Math.floor without touching the
       viewer's own timezone or the Date object's local getters. The
       shift cancels out when we subtract two of these shifted values, so
       the resulting countdown duration is always correct real time. */
    function msUntilNextReset() {
      var istNow = Date.now() + IST_OFFSET_MS;
      var dayStart = Math.floor(istNow / MS_PER_DAY) * MS_PER_DAY;
      var sinceAnchorToday = istNow - (dayStart + anchorMs);
      var cyclesPassed = Math.floor(sinceAnchorToday / cycleMs);
      var nextBoundary = dayStart + anchorMs + (cyclesPassed + 1) * cycleMs;
      return nextBoundary - istNow;
    }

    function tick() {
      var remaining = Math.max(msUntilNextReset(), 0);
      var totalSeconds = Math.floor(remaining / 1000);
      var h = Math.floor(totalSeconds / 3600);
      var m = Math.floor((totalSeconds % 3600) / 60);
      var s = totalSeconds % 60;
      countdownEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---- Count-up stat numbers (IntersectionObserver) ---- */
  var countEls = root.querySelectorAll('[data-ed-countup]');
  if (countEls.length && 'IntersectionObserver' in window) {
    var counted = new WeakSet();
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || counted.has(entry.target)) return;
          counted.add(entry.target);
          animateCount(entry.target);
        });
      },
      { threshold: 0.4 }
    );
    countEls.forEach(function (el) { observer.observe(el); });
  }

  function animateCount(el) {
    var raw = el.getAttribute('data-ed-countup');
    var match = raw.match(/^([\d.]+)(.*)$/);
    if (!match) { return; }
    var target = parseFloat(match[1]);
    var suffix = match[2] || '';
    var isDecimal = match[1].indexOf('.') !== -1;
    var duration = 1100;
    var start = null;

    function step(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = target * eased;
      el.textContent = (isDecimal ? value.toFixed(1) : Math.round(value)) + suffix;
      if (progress < 1) window.requestAnimationFrame(step);
      else el.textContent = raw;
    }
    window.requestAnimationFrame(step);
  }

  /* ---- Sticky add-to-cart bar visibility ---- */
  var mainAtcAnchor = root.querySelector('[data-ed-atc-anchor]');
  if (stickyBar && mainAtcAnchor && 'IntersectionObserver' in window) {
    var barObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var isVisible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-visible', isVisible);
          document.body.classList.toggle('ed-sticky-atc-active', isVisible);
        });
      },
      { threshold: 0 }
    );
    barObserver.observe(mainAtcAnchor);
  }

  /* ---- Accordions (description + FAQ) ---- */
  root.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ed-accordion-trigger]');
    if (!trigger) return;
    var item = trigger.closest('[data-ed-accordion-item]');
    if (!item) return;
    var isOpen = item.classList.contains('is-open');
    var group = item.closest('[data-ed-accordion-group]');
    if (group && group.hasAttribute('data-ed-accordion-single')) {
      group.querySelectorAll('[data-ed-accordion-item]').forEach(function (i) {
        if (i !== item) i.classList.remove('is-open');
      });
    }
    item.classList.toggle('is-open', !isOpen);
  });

  /* ---- Share button ---- */
  var shareBtn = root.querySelector('[data-ed-share]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      var shareData = { title: document.title, url: window.location.href };
      if (navigator.share) {
        navigator.share(shareData).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(shareData.url).then(function () {
          var original = shareBtn.getAttribute('data-ed-label') || shareBtn.textContent;
          shareBtn.textContent = 'Link copied';
          window.setTimeout(function () { shareBtn.textContent = original; }, 1800);
        });
      }
    });
  }
})();
